import { use, createContext } from "react";
import { AuthState, initialContext } from "./AuthState";
interface AuthContextValue extends AuthState {
  signIn: () => void;
  signOut: () => void;
}
export const AuthContext = createContext<AuthContextValue>(initialContext);
export const useAuth = () => use(AuthContext);
